/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

import type { App } from 'vue'
import GoogleSignInPlugin from 'vue3-google-signin'
import { getProjectConfig } from '@/shared/projectEnvVariables.ts'
import router from '../router'
import pinia from '../stores'
import vuetify from './vuetify'

export function registerPlugins (app: App) {
  app
    .use(vuetify)
    .use(router)
    .use(pinia)
    .use(GoogleSignInPlugin, {
      clientId: getProjectConfig().VITE_GOOGLE_CLIENT_ID,
    })
}
